import React from 'react';
import * as Icons from '../../Icons';

const OptionCardIcon = ({ iconName }) => {
  const IconComponent = Icons[`Icon${iconName}`];
  return (
    <div className="ml-4 flex items-center" aria-hidden>
      <IconComponent size="10" />
    </div>
  );
};

export default OptionCardIcon;
